var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "payment-third-border" }, [
      _c("div", { staticClass: "payment-third-content-parent" }, [
        _c("div", { staticClass: "payment-third-row1" }, [
          _c("img", {
            staticClass: "payment-img1-style",
            attrs: { src: require("../../assets/payment-third-1-1x.png") }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "payment-third-row1-content" }, [
            _c("div", { staticClass: "payment-third-1-sequence" }, [
              _vm._v("01")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "payment-third-1-title" }, [
              _vm._v("Get the terms you need for your business")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "payment-third-1-content" }, [
              _vm._v(
                "When determining your limit, we take into account factors like your business type, size, and location, as well as your payment history, revenue, and financial information."
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "payment-third-1-content2" }, [
              _vm._v(
                "And, much like a credit card, your net 60 terms limit can change over time, given ongoing changes to your business."
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "payment-third-row2" }, [
          _c("div", { staticClass: "payment-third-row2-content" }, [
            _c("div", { staticClass: "payment-third-2-sequence" }, [
              _vm._v("02")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "payment-third-2-title" }, [
              _vm._v("Sell products before you pay")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "payment-third-2-content" }, [
              _vm._v(
                "We give you net 60 terms to empower you to buy and sell goods without having to pay for them upfront. This means you can hold onto your cash to cover costs like rent or payroll, while still stocking up on new inventory."
              )
            ])
          ]),
          _vm._v(" "),
          _c("img", {
            staticClass: "payment-img2-style",
            attrs: { src: require("../../assets/payment-third-2-1x.png") }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "payment-third-row2-mobile" }, [
          _c("img", {
            staticClass: "payment-img2-style",
            attrs: { src: require("../../assets/payment-third-2-1x.png") }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "payment-third-row2-content" }, [
            _c("div", { staticClass: "payment-third-2-sequence" }, [
              _vm._v("02")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "payment-third-2-title" }, [
              _vm._v("Sell products before you pay")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "payment-third-2-content" }, [
              _vm._v(
                "We give you net 60 terms to empower you to buy and sell goods without having to pay for them upfront. This means you can hold onto your cash to cover costs like rent or payroll, while still stocking up on new inventory."
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "payment-third-row3" }, [
          _c("img", {
            staticClass: "payment-img3-style",
            attrs: { src: require("../../assets/payment-third-3-1x.png") }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "payment-third-row3-content" }, [
            _c("div", { staticClass: "payment-third-3-sequence" }, [
              _vm._v("03")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "payment-third-3-title" }, [
              _vm._v("Don’t worry about fees or penalties, ever.")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "payment-third-3-content" }, [
              _vm._v(
                "There no fee for paying with terms, and there’s no penalty for using your entire terms limit. As you pay off invoices, those amounts are returned to your available net 60 terms, so you can place more orders."
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "payment-third-3-content2" }, [
              _vm._v("Need more terms? You can always apply for an increase.")
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12e6e7c7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12e6e7c7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/credit-payment/payment-third.vue
// module id = null
// module chunks = 